import moment from "moment";
import { BudgetPeriod } from "@/services/cloudchipr.api";
import { getFQuarterByStartMonth } from "@/components/common/date-range-picker/utils/preDefinedRanges/getQuarterlyPreDefinedRange";

export const getPlannedBudgetsMap = (
  budgetStartDate?: string,
  period?: BudgetPeriod,
  plannedBudgets?: number[] | null,
  quarterStartMonth?: number,
) => {
  const startMonth = moment(budgetStartDate ?? "").month();

  const { quarter } = getFQuarterByStartMonth(
    moment(budgetStartDate).month() + 1,
    quarterStartMonth,
  );

  const startDate = period === "monthly" ? startMonth : quarter;

  return plannedBudgets?.reduce(
    (acc, current, index) => {
      const arrayIndex =
        period === "monthly"
          ? (startDate + index) % 12
          : (startDate + index) % 4 || quarterIndexForZeroRemainder;

      acc[arrayIndex] = current;

      return acc;
    },
    {} as Record<number, number>,
  );
};

const quarterIndexForZeroRemainder = 4; // To ensure that the quarter index starts from 1 instead of 0
